 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","19":"pdfjsWorker","22":"stencil-ion-action-sheet-ios-entry-js","23":"stencil-ion-action-sheet-md-entry-js","24":"stencil-ion-alert-ios-entry-js","25":"stencil-ion-alert-md-entry-js","26":"stencil-ion-app_8-ios-entry-js","27":"stencil-ion-app_8-md-entry-js","28":"stencil-ion-avatar_3-ios-entry-js","29":"stencil-ion-avatar_3-md-entry-js","30":"stencil-ion-back-button-ios-entry-js","31":"stencil-ion-back-button-md-entry-js","32":"stencil-ion-backdrop-ios-entry-js","33":"stencil-ion-backdrop-md-entry-js","34":"stencil-ion-button_2-ios-entry-js","35":"stencil-ion-button_2-md-entry-js","36":"stencil-ion-card_5-ios-entry-js","37":"stencil-ion-card_5-md-entry-js","38":"stencil-ion-checkbox-ios-entry-js","39":"stencil-ion-checkbox-md-entry-js","40":"stencil-ion-chip-ios-entry-js","41":"stencil-ion-chip-md-entry-js","42":"stencil-ion-col_3-entry-js","43":"stencil-ion-datetime_3-ios-entry-js","44":"stencil-ion-datetime_3-md-entry-js","45":"stencil-ion-fab_3-ios-entry-js","46":"stencil-ion-fab_3-md-entry-js","47":"stencil-ion-img-entry-js","48":"stencil-ion-infinite-scroll_2-ios-entry-js","49":"stencil-ion-infinite-scroll_2-md-entry-js","50":"stencil-ion-input-ios-entry-js","51":"stencil-ion-input-md-entry-js","52":"stencil-ion-item-option_3-ios-entry-js","53":"stencil-ion-item-option_3-md-entry-js","54":"stencil-ion-item_8-ios-entry-js","55":"stencil-ion-item_8-md-entry-js","56":"stencil-ion-loading-ios-entry-js","57":"stencil-ion-loading-md-entry-js","58":"stencil-ion-menu_3-ios-entry-js","59":"stencil-ion-menu_3-md-entry-js","60":"stencil-ion-modal-ios-entry-js","61":"stencil-ion-modal-md-entry-js","62":"stencil-ion-nav_2-entry-js","63":"stencil-ion-popover-ios-entry-js","64":"stencil-ion-popover-md-entry-js","65":"stencil-ion-progress-bar-ios-entry-js","66":"stencil-ion-progress-bar-md-entry-js","67":"stencil-ion-radio_2-ios-entry-js","68":"stencil-ion-radio_2-md-entry-js","69":"stencil-ion-range-ios-entry-js","70":"stencil-ion-range-md-entry-js","71":"stencil-ion-refresher_2-ios-entry-js","72":"stencil-ion-refresher_2-md-entry-js","73":"stencil-ion-reorder_2-ios-entry-js","74":"stencil-ion-reorder_2-md-entry-js","75":"stencil-ion-ripple-effect-entry-js","76":"stencil-ion-route_4-entry-js","77":"stencil-ion-searchbar-ios-entry-js","78":"stencil-ion-searchbar-md-entry-js","79":"stencil-ion-segment_2-ios-entry-js","80":"stencil-ion-segment_2-md-entry-js","81":"stencil-ion-select_3-ios-entry-js","82":"stencil-ion-select_3-md-entry-js","83":"stencil-ion-slide_2-ios-entry-js","84":"stencil-ion-slide_2-md-entry-js","85":"stencil-ion-spinner-entry-js","86":"stencil-ion-split-pane-ios-entry-js","87":"stencil-ion-split-pane-md-entry-js","88":"stencil-ion-tab-bar_2-ios-entry-js","89":"stencil-ion-tab-bar_2-md-entry-js","90":"stencil-ion-tab_2-entry-js","91":"stencil-ion-text-entry-js","92":"stencil-ion-textarea-ios-entry-js","93":"stencil-ion-textarea-md-entry-js","94":"stencil-ion-toast-ios-entry-js","95":"stencil-ion-toast-md-entry-js","96":"stencil-ion-toggle-ios-entry-js","97":"stencil-ion-toggle-md-entry-js","98":"stencil-ion-virtual-scroll-entry-js","99":"stencil-polyfills-core-js","100":"stencil-polyfills-css-shim","101":"stencil-polyfills-dom"}[chunkId]||chunkId) + "-es2015." + {"0":"e28233de025236d291b1","1":"30ae1395af87413d4ca8","2":"26bf55e75420164b66c5","3":"0a508a6fa032ae7e274a","5":"d26103ce05db9eb966b5","6":"1323a93cd9aedd219f0f","7":"bf7a1030a6392043906c","8":"3cca4212c81578640fef","9":"61c998ed5e321fc6002b","10":"cb5fe971d7d1a69509e1","11":"9378c97768245611ca5c","12":"556d711cb88c0545a13c","13":"c0e0f4ae3fbf29b9d682","14":"11b69afe4f1147138742","15":"4341d8feee616d46d498","16":"ae2e86bcefde456fabdf","17":"c1483b5ca7a636f41de7","19":"ab8a690a7109f602a21f","22":"e67625aa45968ee59541","23":"0132f38e0845151e1923","24":"bd77bce64218dce20d0f","25":"3b4d1dcdeb2f899090d4","26":"479b42310152e49c2489","27":"31e4cdf15233bb3872ff","28":"bec7374dbf753a3e2d8b","29":"e86435383ab953d0f04f","30":"4fd5d1a3636ef281038b","31":"367b20f89a1ffe9f6538","32":"5094d672c4bdd58fc33f","33":"dd157dbbebd4f32012b4","34":"0a3254a01a8379832415","35":"e83e0d68adbd1a56aa50","36":"86dce8563fc9474cdc9e","37":"f6ca064efefac31252e8","38":"0c28ffc5101c74094a6c","39":"be455fce0ecd6156b179","40":"8b2041b44df30644fba9","41":"0634c84237af0088fcd9","42":"9c4ec4c0b58a49ae5cea","43":"5f43ef14c1433be37add","44":"d6712df9333693dfe13b","45":"7ed91e421110f7f96284","46":"24adb71b4235fcfcc4ab","47":"fd1d20c0683e19423d06","48":"7ab038dad3f087b5dfbb","49":"f518ae17874434f32879","50":"0f7acdf95f96aeca048d","51":"7a1632cd9a9fe4f1834f","52":"b9aa2c575a1b3055a6b5","53":"d6097337d4dbd7f9b34b","54":"25e4f6b73e3cf2038ef9","55":"761bf74d3e7cac9bd1b5","56":"26917fb366b80fec18bc","57":"75924f756414ded638b1","58":"3824010c9c44465a93f5","59":"8e6d60c53143975c42fd","60":"e864441a843d7c644df6","61":"4050975d93fa5961bdba","62":"6f5a1a137d46c7e515c8","63":"3a3a6f0627c8c282510b","64":"09be4f05dd36f4dd7fd5","65":"320a00dae517dd5b3be5","66":"b5ac3d10ce7c4a2b2b69","67":"e370a1ec4778104a2adc","68":"69a0288fe54851303622","69":"bf3bed9f782ab213eb4b","70":"815109cb1f7f615b9776","71":"7d5894478b2729baf54a","72":"b591b6423613e8a6402e","73":"4e8644ed2644ccdb6d10","74":"ac77cc73f7a50f0870f7","75":"4e5a0911e8d29bc615cb","76":"a928084d07c2e9877a2d","77":"c9485ce645ffadd313cf","78":"e6cb9b42534ed0ee5ab3","79":"33e8272eca83ab996ea5","80":"dff2fdf9c419d3e04a49","81":"821c5fd5c5373cfd90b1","82":"2659cf601adaaf971128","83":"3e7cf7af6f43edc60fd9","84":"b6fd3084135a44e8712d","85":"2206c201c8169fcd9b4d","86":"f2cce8ffef3765b9b549","87":"c958e02667f00b630132","88":"5e6ed5f86790a671c753","89":"7fa6ae1f48cda920f6a5","90":"1a80c89ecd1940f065bb","91":"007397489e9b1d71040c","92":"a7fedc9206483c92c867","93":"78471b83091014220aff","94":"8252d1a297e63d42f2ce","95":"cdb72ff04805011be0ce","96":"c30cb4a946e61f0385bd","97":"a930db2cd6a65e78aa2a","98":"b68f341a84846861ead9","99":"cbd44ae6ec04ebfc33c1","100":"0f4ba2e79bcfa79a826f","101":"c83dfe4313abe14434b7","103":"8f0b83caf088857f3469","104":"6dabeb809e3aacabd64b","105":"2ddb4f075bacdd7db584","106":"084d16009c687bbf443c","107":"ad5cf00d632dee82a5ea","108":"d28d338584a29064624a","109":"91c76b5720a38ab7725c","110":"d06ddd7e3c08be8daf69","111":"7b3c25776dee8ff586c5","112":"3d4ff2b453855b03156b","113":"b4621a31c8fdf125f921","114":"b50611b1cf17edfbbd6d","115":"c30811dd03a253beed8f","116":"8dae6c04327f42246668","117":"89661886ab08ac655da8","118":"7e87e5795f0957b0e24c","119":"a3c91e5cfc67e4dc1fe1","120":"8184f7ff2861bf31c01d","121":"1ebf6488fd69c999d6af","122":"dfe85a855f93c60e2127","123":"2f3dc3f124fe7213d375","124":"e1bc71d4764e80c1b416","125":"41f99af9665ab3947b8c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
